import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { LogOut } from 'lucide-react';
import CompanyLogo from './CompanyLogo';
import { useAuth } from '../context/AuthContext';

const PageHeader = ({ title, showLogout = true, className = '' }) => {
  const navigate = useNavigate();
  const { logout, company } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/signin');
  };

  return (
    <div className={`bg-gradient-to-r from-blue-600 to-green-600 text-white shadow-lg ${className}`}>
      <div className="w-full px-3 sm:px-4 md:px-6 lg:px-8 py-3 sm:py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-3 min-w-0 flex-shrink">
            <CompanyLogo 
              company={company} 
              className="h-8 sm:h-10 object-contain bg-[#1A2433] rounded px-1 sm:px-2 py-1" 
            />
            {title && (
              <h1 className="text-lg sm:text-xl md:text-2xl font-bold truncate">
                {title}
              </h1>
            )}
          </div>
          {showLogout && (
            <Button 
              onClick={handleLogout}
              variant="outline"
              size="sm"
              className="bg-[#1A2433]/10 border-white/30 text-white hover:bg-[#1A2433]/20 hover:text-white text-xs sm:text-sm px-2 sm:px-3 flex-shrink-0"
            >
              <LogOut className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
              <span className="hidden xs:inline">Logout</span>
              <span className="xs:hidden">Out</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
